import React, { useEffect, useRef, memo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";

const ThumbnailSlider = memo(
  ({ images, mainSwiper, activeIndex, onSwiper, initialSlide = 0 }) => {
    const swiperRef = useRef(null);

    useEffect(() => {
      if (swiperRef.current && swiperRef.current.swiper) {
        const swiper = swiperRef.current.swiper;
        onSwiper(swiper);
        swiper.slideTo(initialSlide, 0);
      }
    }, [onSwiper, initialSlide]);

    useEffect(() => {
      if (
        swiperRef.current &&
        swiperRef.current.swiper &&
        activeIndex !== undefined
      ) {
        swiperRef.current.swiper.slideTo(activeIndex);
      }
    }, [activeIndex]);

    const getBestThumbnail = (image) => {
      return (
        image.thumbnail_110_url ||
        image.thumbnail_url ||
        "https://via.placeholder.com/150x100?text=Thumbnail+Not+Available"
      );
    };

    return (
      <div className="mt-4">
        <Swiper
          ref={swiperRef}
          slidesPerView={5}
          spaceBetween={10}
          freeMode={true}
          watchSlidesProgress={true}
          breakpoints={{
            640: { slidesPerView: 10 },
            768: { slidesPerView: 10 },
            1024: { slidesPerView: 15 },
            1280: { slidesPerView: 20 },
          }}
          modules={[FreeMode]}
          className="thumbnailSwiper bg-gray-500 p-[15px]"
        >
          {images.map((image, index) => (
            <SwiperSlide
              key={`thumb-${image.id}`}
              onClick={() => mainSwiper.slideTo(index)}
              className={`cursor-pointer transition-all duration-300 hover:opacity-100 ${
                index === activeIndex
                  ? "opacity-100 border-2 border-blue-500"
                  : "opacity-60 border-2 border-transparent"
              }`}
            >
              <img
                src={getBestThumbnail(image)}
                alt={`Thumbnail ${index + 1}`}
                className="w-full h-20 object-cover rounded"
                loading="lazy"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.mainSwiper === nextProps.mainSwiper &&
      prevProps.activeIndex === nextProps.activeIndex &&
      prevProps.initialSlide === nextProps.initialSlide &&
      prevProps.images.length === nextProps.images.length
    );
  }
);

export default ThumbnailSlider;
